import { fetchMetrics } from '../helpers';

export const recommendationInit = () => {
  document.addEventListener('recommendation:load', ({ detail }) => {
    const shelf = detail.shelves.shelves.find(shelf => shelf.type === 'item_page.ads');

    if (!shelf || !shelf.products) {
      return null;
    }

    shelf.products
      .map(product => product.attributes)
      .filter(attribute => attribute.pixel && attribute.pixel.length > 0)
      .map(attribute => attribute.pixel[0])
      .filter(pixel => pixel.indexOf('https://') === 0)
      .map(fetchMetrics);
  });
};
